






















import Vue from "vue";
import Translations from './services/Translations';

export default Vue.extend({
  name: "App",

  mounted(){
    window.addEventListener('scroll', this.checkScroll.bind(this))
    window.addEventListener('resize', this.checkViewPort.bind(this))
    this.checkScroll();
    this.checkViewPort();
  },
  data: () => ({
    showScrollButton: false,
    viewPort: document.querySelector("meta[name=viewport]"),
    portScale: 1
  }),
  watch: {
      $route(to, from) {
          if(!to.meta.key){
              document.title = Translations.translate('mainTitle') || '';
          }else{
            document.title = `${Translations.translate('views.' + to.meta.key)} | ${Translations.translate('mainTitle')}` 
          }
      }
  },
  methods: {
    scrollUp(){
        window.scroll({top: 0, left: 0, behavior: 'smooth' })
    },
    checkScroll(){
        this.showScrollButton = window.scrollY > 600;
    },
    checkViewPort(){
      if(!this.viewPort) return;

      let scale = this.portScale;
      if(window.outerWidth < 330){
          scale = 0.75
      }else if(window.outerWidth < 370){
        scale = 0.9
      }else{
        scale = 1;
      }

      if(this.portScale != scale){
        this.portScale = scale;
        this.viewPort.setAttribute("content", `width=device-width,initial-scale=${scale}`)
      }

    }
  }
});
